import { api } from "../App";
import { SET_IMPORTING_PHOTOS_LIST, SET_IMPORTING_PHOTOS_LOADING } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getImportingPhotosList = () => async (dispatch) => {
    try {
        dispatch({ type: SET_IMPORTING_PHOTOS_LOADING, payload: true });
        const { data } = await api.get('/photo_import');
        dispatch({ type: SET_IMPORTING_PHOTOS_LIST, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_IMPORTING_PHOTOS_LOADING, payload: false });
    }
}

export const createImportingPhotosList = (file) => async (dispatch) => {
    try {
        const fd = new FormData();
        fd.append("file", file);
        await api.post(`/photo_import`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    }
};
